import ArticleCarousel from "../src/components/article/ArticleCarousel";
import DefaultProject from "../src/components/defaultProject";
import AllProjectPreview from "../src/components/project/AllProjectPreview";
import FavProjectPreview from "../src/components/project/FavProjectPreview";

export const customComponentsConstructorClassification = {
  basicComponents: {
    DefaultProject,
    FavProjectPreview,
    AllProjectPreview,
    ArticleCarousel,
  },
  basicContainers: {},
  complexContainers: {},
};

export const customComponents = [
  {
    node: "portfolio",
    children: [
      {
        node: "DefaultProject",
        type: "Component",
        editorIcon: "grid_guides",
        title: "default",
        description:
          "this is the default description of the template default project, it is auto generate when we create a React component of this type but it will appear only when we use it without the cms",
        image: {
          editorType: "language",
          fr: {
            editorType: "imageSelector",
            value:
              "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2Fplaceholder%2Fplaceholder.png?alt=media&token=499319ad-3327-4f5c-84cb-b44027484cfe",
            title: "placeholder.png",
          },
          en: {
            editorType: "imageSelector",
            value: "",
            title: "",
          },
        },
        backgroundTexture: {
          editorType: "language",
          fr: {
            editorType: "imageSelector",
            value:
              "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2Fbackground%2Fbackground.webp?alt=media&token=284d854e-4e04-476e-866b-ae16a3de90b4",
            title: "background.webp",
          },
          en: {
            editorType: "imageSelector",
            value: "",
            title: "",
          },
        },
      },
      {
        node: "ArticleCarousel",
        type: "Component",
        editorIcon: "view_carousel",
        normalImage: {
          editorType: "imageSelector",
          value:
            "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2FCarousel%2FShowMore%2FarticleArrow.png?alt=media&token=15afc48e-b9e0-4abd-b33d-932dcce1707a",
          title: "articleArrow.png",
        },
        hoverImage: {
          editorType: "imageSelector",
          value:
            "https://firebasestorage.googleapis.com/v0/b/liro-u.appspot.com/o/GUI%2FCarousel%2FShowMore%2FarticleArrowHover.png?alt=media&token=33651819-15b6-42e3-b1bc-7a2132fd972b",
          title: "articleArrowHover.png",
        },
        switchRotation: false,
        switchDirection: false,
        autoChange: true,
        width: "500px",
        height: "281px",
        delay: 5000,
        linkTo: "",
        nbSlide: 3,
        nbArticlePerSlide: 2,
      },
      {
        node: "FavProjectPreview",
        type: "Component",
        editorIcon: "stack_star",
        gameTitle: {
          editorType: "language",
          fr: "Mes Jeux",
          en: "My Games",
        },
        jamTitle: {
          editorType: "language",
          fr: "Mes Jams",
          en: "My Jams",
        },
        webTitle: {
          editorType: "language",
          fr: "Mes Sites",
          en: "My WebSite",
        },
        noResultText: {
          editorType: "language",
          fr: "Pas de projet correspondant",
          en: "No Project Found",
        },
        moreText: {
          editorType: "language",
          fr: "Voir Plus",
          en: "See More",
        },
      },
      {
        node: "AllProjectPreview",
        type: "Component",
        editorIcon: "view_list",
        ProjectType: "GAME",
      },
    ],
  },
];
